function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Drawer, message, Tree, Modal, Table, Tabs, notification } from 'antd';
import { NodePlusFill, XSquareFill, TrashFill, PencilFill, EyeFill, PlusCircleFill, PlusSquare, PencilSquare } from 'react-bootstrap-icons';
import NewDepartment from "../components/forms/NewDepartment";
import NewExam from "../components/forms/NewExam";
import Common from "../components/includes/Common";
import ItemView from "../components/ItemView";
import EditItem from "../components/forms/EditItem";
import AddTemplateReport from "../components/forms/AddReportTemplate";
import EditReportTemplate from "../components/forms/EditReportTemplate";
import AddPrescriber from "../components/forms/AddPrescriber";
import EditPrescriber from "../components/forms/EditPrescriber";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var Departments = function Departments() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewDeptFormVisible = _useState2[0],
    setIsNewDeptFormVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewItemFormVisible = _useState4[0],
    setIsNewItemFormVisible = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    serviceTree = _useState6[0],
    setServiceTree = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dataChanged = _useState8[0],
    setDataChanged = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataChangedRt = _useState0[0],
    setDataChangedRt = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    dataChangedPr = _useState10[0],
    setDataChangedPr = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedItem = _useState12[0],
    setSelectedItem = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    itemViewVisible = _useState14[0],
    setItemViewVisible = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    itemEditVisible = _useState16[0],
    setItemEditVisible = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    itemsArray = _useState18[0],
    setItemsArray = _useState18[1];
  var _useState19 = useState(true),
    _useState20 = _slicedToArray(_useState19, 2),
    isDataLoading = _useState20[0],
    setIsDataLoading = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showAddReportTemplate = _useState22[0],
    setShowAddReportTemplate = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showEditReportTemplate = _useState24[0],
    setShowEditReportTemplate = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    templates = _useState26[0],
    setTemplates = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedRt = _useState28[0],
    setSelectedRt = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    selectedPrescriber = _useState30[0],
    setSelectedPrescriber = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showAddPrescriber = _useState32[0],
    setShowAddPrescriber = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showEditPresciber = _useState34[0],
    setShowEditPrescriber = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    prescribers = _useState36[0],
    setPrescribers = _useState36[1];
  var pcols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Nom"
    }),
    dataIndex: "name",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Mobible"
    }),
    dataIndex: "mobile",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "mobile"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Balance"
    }),
    dataIndex: "balance",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "mobile"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: "action",
    render: function render(p) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedPrescriber(p);
              setShowEditPrescriber(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              handleDeletePrescriber(p);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(TrashFill, {
                size: 22
              })
            })
          })]
        })
      });
    },
    key: "description"
  }];
  var rtCols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Titre"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Desc."
    }),
    dataIndex: "description",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "description"
  }, {
    title: /*#__PURE__*/_jsx("b", {}),
    dataIndex: "action",
    render: function render(t) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              setSelectedRt(t);
              setShowEditReportTemplate(true);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(PencilSquare, {
                size: 22
              })
            })
          }), /*#__PURE__*/_jsx(Button, {
            type: "default",
            onClick: function onClick() {
              handleDeleteRt(t);
            },
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(TrashFill, {
                size: 22
              })
            })
          })]
        })
      });
    },
    key: "description"
  }];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Acte/Service"
    }),
    dataIndex: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    },
    key: "label"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Dept."
    }),
    dataIndex: "category",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "category"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif part."
    }),
    dataIndex: "base_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "base_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif soc."
    }),
    dataIndex: "ent_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "ent_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif assur."
    }),
    dataIndex: "ins_price",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "ins_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Tarif lanala"
    }),
    dataIndex: "lan_price",
    render: function render(text) {
      text && /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "lan_price"
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Actions"
    }),
    dataIndex: "action",
    render: function render(item) {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleViewItem(item);
          },
          children: /*#__PURE__*/_jsx(EyeFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleEditItem(item);
          },
          children: /*#__PURE__*/_jsx(PencilFill, {
            size: 20
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            return handleDeleteItem(item);
          },
          children: /*#__PURE__*/_jsx(TrashFill, {
            size: 20
          })
        })]
      });
    },
    key: "action"
  }];
  var handleDeleteRt = function handleDeleteRt(t) {
    setSelectedRt(t);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du compte rendu type - ", t.label, " ?"]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deletereporttemplate/" + Common.currentUser.id + "/" + t.id.toString()).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleDeletePrescriber = function handleDeletePrescriber(p) {
    setSelectedRt(p);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["La suppression du medecin prescripteur - ", p.name, " ?"]
      }),
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteprescriber/" + Common.currentUser.id + "/" + p.id.toString()).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Erreur!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  var handleViewItem = function handleViewItem(item) {
    setSelectedItem(item);
    setItemViewVisible(true);
  };
  var handleEditItem = function handleEditItem(item) {
    setSelectedItem(item);
    setItemEditVisible(true);
  };
  var handleDeleteItem = function handleDeleteItem(item) {
    setSelectedItem(item);
    Modal.confirm({
      title: "Confirmez-vous ?",
      content: "La suppression de " + item.label,
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deleteitem/" + selectedItem.key.toString() + "/" + Common.currentUser.id.toString()).then(function (response) {
          if (response.status == 200) {
            setDataChanged(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 4
          });
        })["finally"](function () {});
      }
    });
  };
  var tabItems = [{
    key: 1,
    label: /*#__PURE__*/_jsx("b", {
      children: "Comptes rendu type"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Button, {
              type: "default",
              onClick: function onClick() {
                setShowAddReportTemplate(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PlusSquare, {
                  size: 22
                })
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: rtCols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: templates,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsx("b", {
      children: "Med. Prescripteur"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Button, {
              type: "default",
              onClick: function onClick() {
                setShowAddPrescriber(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(PlusSquare, {
                  size: 22
                })
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: pcols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: prescribers,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }, {
    key: 3,
    label: /*#__PURE__*/_jsx("b", {
      children: "Articles"
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Space, {
              direction: "horizontal",
              children: /*#__PURE__*/_jsxs(Button, {
                type: "primary",
                style: {
                  width: '98%'
                },
                icon: /*#__PURE__*/_jsx(NodePlusFill, {
                  size: 26
                }),
                onClick: function onClick() {
                  setIsNewItemFormVisible(true);
                },
                children: [" ", /*#__PURE__*/_jsx("b", {
                  children: "Ajouter un article"
                })]
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "white-bg cool-radius",
              children: /*#__PURE__*/_jsx(Table, {
                size: "small",
                columns: cols,
                bordered: true,
                sticky: false,
                loading: isDataLoading,
                dataSource: itemsArray,
                pagination: true
              })
            })]
          })
        })
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + 'getitems').then(function (response) {
      if (response.data.status == 200) {
        setItemsArray([]);
        response.data.products.forEach(function (s) {
          setItemsArray(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: s.id.toString() + "tab",
              label: s.label,
              category: s.department != null ? s.department.label : "NA",
              base_price: s.base_price,
              ent_price: s.ent_price,
              ins_price: s.ins_price,
              lan_price: s.lan_price,
              action: s
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getreporttemplates/" + Common.currentUser.id).then(function (response) {
      setTemplates([]);
      if (response.data.status == 200) {
        response.data.templates.forEach(function (e) {
          setTemplates(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: e.label,
              description: e.description,
              content: e.content,
              action: e
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedRt(false);
    });
  }, [dataChangedRt]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getprescribers/" + Common.currentUser.id).then(function (response) {
      setPrescribers([]);
      if (response.data.status == 200) {
        response.data.prescribers.forEach(function (p) {
          setPrescribers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              name: p.name,
              mobile: p.mobile,
              balance: p.balance,
              action: p
            }]);
          });
        });
      }
    })["catch"](function (error) {})["finally"](function () {
      setDataChangedPr(false);
    });
  }, [dataChangedPr]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tabs, {
      items: tabItems,
      animated: true
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewDeptFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un d\xE9partement",
      onClose: function onClose() {
        setIsNewDeptFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewDepartment, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isNewItemFormVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      width: 370,
      destroyOnClose: true,
      title: "Ajouter un acte/examen",
      onClose: function onClose() {
        setIsNewItemFormVisible(false);
      },
      closable: true,
      children: /*#__PURE__*/_jsx(NewExam, {
        handler: function handler() {
          setDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: itemViewVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Details",
      onCancel: function onCancel() {
        setItemViewVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(ItemView, {
        item: selectedItem
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: itemEditVisible,
      closeIcon: /*#__PURE__*/_jsx(XSquareFill, {
        size: 25
      }),
      destroyOnClose: true,
      title: "Modifier",
      onCancel: function onCancel() {
        setItemEditVisible(false);
      },
      footer: null,
      closable: true,
      children: /*#__PURE__*/_jsx(EditItem, {
        handler: function handler() {
          setDataChanged(true), setItemEditVisible(false);
          message.success({
            content: "Modifications enregistrées",
            delay: 4
          });
        },
        item: selectedItem
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddReportTemplate,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "NOUVEAU COMPTE RENDU TYPE"
      }),
      onClose: function onClose() {
        setShowAddReportTemplate(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(AddTemplateReport, {
        handler: function handler() {
          setDataChangedRt(true);
          setShowAddReportTemplate(false);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: showAddPrescriber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowAddPrescriber(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(AddPrescriber, {
        handler: function handler() {
          setDataChangedPr(true);
          setShowAddPrescriber(false);
        }
      })
    }), selectedRt && /*#__PURE__*/_jsx(Drawer, {
      open: showEditReportTemplate,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE COMPTE RENDU TYPE"
      }),
      onClose: function onClose() {
        setShowEditReportTemplate(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(EditReportTemplate, {
        template: selectedRt,
        handler: function handler() {
          setDataChangedRt(true);
          setShowEditReportTemplate(false);
        }
      })
    }), selectedPrescriber && /*#__PURE__*/_jsx(Drawer, {
      open: showEditPresciber,
      destroyOnClose: true,
      title: /*#__PURE__*/_jsx("b", {
        children: "MODIFIER LE PRESCRIPTEUR"
      }),
      onClose: function onClose() {
        setShowEditPrescriber(false);
      },
      width: "80%",
      children: /*#__PURE__*/_jsx(EditPrescriber, {
        prescriber: selectedPrescriber,
        handler: function handler() {
          setDataChangedPr(true);
          setShowEditPrescriber(false);
        }
      })
    })]
  });
};
export default Departments;